import { ButtonProps } from 'common/ui/Button';
import { ReportStatuses } from '../state';

export enum SubmitType {
  Prelim = 'prelim',
  Final = 'final',
}

export type SubmittedAtTime = Date | string;

export type OnSubmitParams = {
  force?: boolean;
  type?: SubmitType;
  onSuccess?: () => void;
  onError?: () => void;
};

export type FieldsButtonProps = {
  countdownSeconds: number | null;
  status: ReportStatuses;
  onSubmit: ((params?: OnSubmitParams) => void) | ((params?: OnSubmitParams) => Promise<void>);
  onCancelSubmit: (() => void) | (() => Promise<void>);
  disabled: boolean;
  isClaimedByMe: boolean;
  isOtherCaseInGroupSubmitting: boolean;
  isCountdownMode: boolean;
};

export type VariantToStatusMapType = Record<
  Extract<ButtonProps['variant'], 'primary' | 'yellow' | 'secondary'>,
  ReportStatuses[]
>;
